import { INVENTORY } from "../helpers/consts";

export class Inventory {
  constructor() {
    this.inventoryMap = new Map();
  }

  has(key) {
    return Boolean(this.inventoryMap.has(key));
  }

  add(key) {
    const existingCount = this.inventoryMap.get(key) ?? 0;
    this.inventoryMap.set(key, existingCount + 1);
  }

  remove(key) {
    this.inventoryMap.delete(key);
  }

  clearAll() {
    //Reset everything else, but preserve flour count and Clown defense
    const wasFlourCount = this.inventoryMap.get(INVENTORY.FLOUR_PICKUP);
    const wasClownCount = this.inventoryMap.get(INVENTORY.CLOWN_DEFENSE);
    this.inventoryMap = new Map();
    if (wasFlourCount) {
      this.inventoryMap.set(INVENTORY.FLOUR_PICKUP, wasFlourCount);
    }
    if (wasClownCount) {
      this.inventoryMap.set(INVENTORY.CLOWN_DEFENSE, wasClownCount);
    }
  }
}
